import { render, staticRenderFns } from "./SystemInvoices.vue?vue&type=template&id=b3d9069a&"
import script from "./SystemInvoices.vue?vue&type=script&lang=js&"
export * from "./SystemInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports